import { render, staticRenderFns } from "./print-layout-2.vue?vue&type=template&id=06e184cc&scoped=true"
import script from "./print-layout-2.vue?vue&type=script&lang=js"
export * from "./print-layout-2.vue?vue&type=script&lang=js"
import style0 from "./print-layout-2.vue?vue&type=style&index=0&id=06e184cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e184cc",
  null
  
)

export default component.exports